import React from 'react';

import DoneIcon from 'material-ui/svg-icons/action/done';

import { TextInput, BooleanInput, SelectInputFromData } from 'components/input';
import { SimpleForm } from 'components/form';

import Edit from 'components/detail/Edit';

import {
  adminUserEditBackendPath
} from './urls';

export const AdminUserEdit = (props) => (
  <Edit editBackendPath={adminUserEditBackendPath} {...props}>
    <SimpleForm submitButtonIcon={<DoneIcon/>} submitButtonLabel="Confirm">
      <TextInput label="Username" source="username"/>
      <TextInput source="first_name" label="First Name" isRequired={true}/>
      <TextInput source="last_name" label="Last Name" isRequired={true}/>
      <BooleanInput defaultValue={false} source="is_active" label="Active" isRequired={true}/>
      <BooleanInput defaultValue={false} source="is_superuser" label="Super User" isRequired={true}/>
      <SelectInputFromData
        label="Group"
        source="group_id"
        choiceSource="group_choices"
      />
    </SimpleForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./src/routes/user/AdminUserEdit.js